import React from 'react';

const ContentLoader = () => {
    return (
        <div className="d-flex justify-content-center align-items-center py-5">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <span className="ms-3 fw-medium">Loading data...</span>
        </div>
    );
};

export default ContentLoader;
